import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Spacing, Text } from '@reservamos/elements';
import 'styles/components/payment/PaymentFormat';

/**
 * PaymentFormatLayout.
 * Standalone, print-oriented layout for the store-payment voucher. Renders full-page without the
 * funnel header/footer/app chrome (parity with frontline's `layout: false`), so it prints cleanly
 * and can be linked from receipts/emails.
 *
 * @param {object} props - Component props.
 * @param {React.ReactNode} props.children - The engine-specific voucher.
 * @returns {JSX.Element} The print layout wrapping the voucher.
 */
const PaymentFormatLayout = ({ children }) => {
  const { t } = useTranslation('payment');

  return (
    <div className="payment-format">
      <div className="payment-format__card">
        <Spacing vertical size="M">
          <Text size="S" textAlign="center" color="grayMedium">
            {t('payment_format.digital_receipt_reminder')}
          </Text>
          {children}
        </Spacing>
      </div>
    </div>
  );
};

PaymentFormatLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PaymentFormatLayout;
